import { Buffer } from 'buffer';

if (typeof window !== 'undefined') {
  window.Buffer = Buffer;
  window.global = window;
  window.process = window.process || {
    env: { NODE_ENV: 'production' },
    browser: true,
    version: '',
    nextTick: function(fn) { setTimeout(fn, 0); }
  };
  
  if (!window.process.version) {
    window.process.version = 'v16.0.0';
  }
  
  const originalIsBuffer = Buffer.isBuffer;
  Buffer.isBuffer = function(obj) {
    if (!obj) return false;
    return originalIsBuffer(obj);
  };
}

export {}; 